module.exports = __webpack_public_path__ + "arrow-left.png?bfed3ea87652b5017f50d0e42559e584";